import { useAnalytics } from '@contexts/AnalyticsContext'

/**
 * Builds in-app links that open a drill-down scoped to the program the page
 * shows, under the `f_` prefix `useTableUrlSync` reads.
 */
const useRevenueLinks = () => {
  const { selectedMembershipPrograms } = useAnalytics()
  const programId = selectedMembershipPrograms?.[0]

  return (path: string, filters: Record<string, string> = {}) => {
    const params = new URLSearchParams()
    if (programId !== undefined) params.set('f_programs', String(programId))
    Object.entries(filters).forEach(([key, value]) =>
      params.set(`f_${key}`, value)
    )
    const query = params.toString()
    return query ? `${path}?${query}` : path
  }
}

export default useRevenueLinks
